import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/lib/chart/funnel";
import "echarts/lib/component/legend";
import "echarts/lib/component/dataset";
import "echarts/lib/component/grid";

const BarChart = ({ data, title }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    const chart = echarts.init(chartRef.current);

    const option = {
      title: { text: "效果统计分析" },
      tooltip: {
        trigger: "item",
        formatter: "{a} <br/>{b} : {c}",
      },
      toolbox: {
        feature: {
          dataView: { readOnly: false },
          restore: {},
          saveAsImage: {},
        },
      },
      legend: {
        data: ["转发量", "页面点击量", "点赞", "评论", "收藏"],
      },
      series: [
        {
          name: "Funnel",
          type: "funnel",
          left: "10%",
          top: 60,
          bottom: 60,
          width: "80%",
          min: 0,
          max: 100,
          minSize: "0%",
          maxSize: "100%",
          sort: "descending",
          gap: 2,
          label: {
            show: true,
            position: "inside",
            formatter: "{c}",
          },
          labelLine: {
            length: 10,
            lineStyle: {
              width: 1,
              type: "solid",
            },
          },
          itemStyle: {
            borderColor: "#fff",
            borderWidth: 1,
          },
          emphasis: {
            label: {
              fontSize: 20,
            },
          },
          data: [
            { value: 60, name: "点赞" },
            { value: 40, name: "评论" },
            { value: 20, name: "收藏" },
            { value: 80, name: "页面点击量" },
            { value: 100, name: "转发量" },
          ],
        },
      ],
    };

    chart.setOption(option);

    const handleResize = () => chart.resize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      chart.dispose();
    };
  }, [data, title]);

  return <div ref={chartRef} style={{ width: "800px", height: "600px" }} />;
};

export default BarChart;
